/* =========================================================
   EGODRIFT Sticky Add-to-Cart
   Version: 1.0.1 — 2026-07-19
   Last change: add missing version header (audit item 5)
========================================================= */
(() => {
  const sticky = document.querySelector('[data-ego-sticky-atc]');
  const dataEl = document.querySelector('[data-ego-sticky-atc-json]');

  if (!sticky || !dataEl) return;

  const titleEl = sticky.querySelector('[data-ego-sticky-atc-title]');
  const priceEl = sticky.querySelector('[data-ego-sticky-atc-price]');
  const imageEl = sticky.querySelector('[data-ego-sticky-atc-image]');
  const stockEl = sticky.querySelector('[data-ego-sticky-atc-stock]');
  const stickyButton = sticky.querySelector('[data-ego-sticky-atc-button]');
  const changeButton = sticky.querySelector('[data-ego-sticky-atc-change]');

  const originalButton = document.querySelector(
    'form[action*="/cart/add"] button[name="add"]'
  );

  if (!originalButton || !stickyButton) return;

  let variantData = {};

  try {
    variantData = JSON.parse(dataEl.textContent);
  } catch (error) {
    console.warn('[EGO STICKY ATC] Could not parse variant data:', error);
    return;
  }

  function updateStockStatus(data) {
    if (!stockEl) return;

    stockEl.textContent = data.available ? 'In stock' : 'Sold out';

    stockEl.classList.toggle(
      'ego-sticky-atc__stock--in',
      data.available
    );

    stockEl.classList.toggle(
      'ego-sticky-atc__stock--out',
      !data.available
    );
  }

  function updateStickyAtc(variantId) {
    const data = variantData[String(variantId)];

    if (!data) return;

    if (titleEl) {
      titleEl.textContent = data.title || '';
    }

    if (priceEl) {
      priceEl.textContent = data.price || '';
    }

    if (imageEl && data.image) {
      imageEl.setAttribute('src', data.image);
      imageEl.setAttribute('alt', data.imageAlt || '');
    }

    updateStockStatus(data);

    stickyButton.disabled = !data.available;

    stickyButton.textContent = data.available
      ? 'Add to cart'
      : 'Sold out';
  }

  function syncButtonState() {
    stickyButton.disabled = originalButton.disabled;

    const originalText = originalButton
      .querySelector('span')
      ?.textContent
      ?.trim();

    if (originalText) {
      stickyButton.textContent = originalText;
    }
  }

  function updateStickyVisibility() {
    const rect = originalButton.getBoundingClientRect();

    sticky.hidden = rect.bottom >= 0;
  }

  stickyButton.addEventListener('click', () => {
    if (stickyButton.disabled) return;

    originalButton.click();
  });

  if (changeButton) {
    changeButton.addEventListener('click', () => {
      const picker = document.querySelector(
        'variant-selects, variant-radios'
      );

      if (picker) {
        picker.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  }

  document.addEventListener('ego:variant-change', event => {
    const variantId = event.detail && event.detail.variantId;

    if (variantId) {
      updateStickyAtc(variantId);

      setTimeout(syncButtonState, 100);
    }
  });

  window.addEventListener(
    'scroll',
    updateStickyVisibility,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    updateStickyVisibility
  );

  const mutationObserver = new MutationObserver(syncButtonState);

  mutationObserver.observe(originalButton, {
    attributes: true,
    childList: true,
    subtree: true
  });

  syncButtonState();
  updateStickyVisibility();
})();